import { render, staticRenderFns } from "./BigListItem.vue?vue&type=template&id=2d4c6762&scoped=true&"
import script from "./BigListItem.vue?vue&type=script&lang=js&"
export * from "./BigListItem.vue?vue&type=script&lang=js&"
import style0 from "./BigListItem.vue?vue&type=style&index=0&id=2d4c6762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c6762",
  null
  
)

export default component.exports